import { axios } from 'lib/axios';

export const loginWithPhoneAndPassword = (data) => {
  return axios.post('/auth/login-user', data);
};
